import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormMixin from '@/amui/mixins/formMixin';
let AmBizSelectKng = class AmBizSelectKng extends Mixins(FormMixin) {
  constructor() {
    super(...arguments);
    this.openPage = false;
  }
  open() {
    this.openPage = true;
  }
  getKngInfo(list) {
    console.log(list, '选择课程数据');
    this.$emit('input', list);
    this.$emit('confirm', list);
    this.openPage = false;
  }
  closePage() {
    this.openPage = false;
  }
};
AmBizSelectKng.componentName = 'AmBizSelectKng';
__decorate([Prop({
  default: 'button'
})], AmBizSelectKng.prototype, "selectType", void 0);
__decorate([Prop({
  default: '选择课程'
})], AmBizSelectKng.prototype, "buttonText", void 0);
__decorate([Prop({
  default: 'primary'
})], AmBizSelectKng.prototype, "buttonType", void 0);
__decorate([Prop({
  default: 10
})], AmBizSelectKng.prototype, "maxNum", void 0);
__decorate([Prop()], AmBizSelectKng.prototype, "kngSelectType", void 0);
__decorate([Prop({
  default: true
})], AmBizSelectKng.prototype, "isRemoveZip", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "excludeFileType", void 0);
__decorate([Prop({
  default: true
})], AmBizSelectKng.prototype, "IsKngMenu", void 0);
__decorate([Prop({
  default: true
})], AmBizSelectKng.prototype, "IsBuyCourseMenu", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "IsBuyProjectMenu", void 0);
__decorate([Prop()], AmBizSelectKng.prototype, "spuCode", void 0);
__decorate([Prop()], AmBizSelectKng.prototype, "spuVersion", void 0);
__decorate([Prop()], AmBizSelectKng.prototype, "projectId", void 0);
__decorate([Prop()], AmBizSelectKng.prototype, "orgId", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "middlePlatform", void 0);
__decorate([Prop({
  type: Array,
  default: []
})], AmBizSelectKng.prototype, "skuCodeList", void 0);
__decorate([Prop({
  type: Array,
  default: []
})], AmBizSelectKng.prototype, "beforeKng", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "isDisabled", void 0);
__decorate([Prop({
  default: true
})], AmBizSelectKng.prototype, "isRemoveHide", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "isRemoveDelete", void 0);
__decorate([Prop({
  default: 0
})], AmBizSelectKng.prototype, "pmType", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "isOpenUpload", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "isHideScore", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "isNoNeedAuth", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "canSelectLibKng", void 0);
__decorate([Prop()], AmBizSelectKng.prototype, "collegeId", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "isAudit", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "isCreateTime", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "filterClosedCollegeData", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "groupSelect", void 0);
__decorate([Prop()], AmBizSelectKng.prototype, "orgDataPermissionCode", void 0);
__decorate([Prop()], AmBizSelectKng.prototype, "orgFunctionCode", void 0);
__decorate([Prop({
  default: false
})], AmBizSelectKng.prototype, "showAllBuyCount", void 0);
__decorate([Prop({
  type: Array,
  default: []
})], AmBizSelectKng.prototype, "disabledRowIds", void 0);
__decorate([Prop({
  default: 2
})], AmBizSelectKng.prototype, "env", void 0);
__decorate([Prop({
  type: Array,
  default: []
})], AmBizSelectKng.prototype, "includeTypes", void 0);
AmBizSelectKng = __decorate([Component({
  name: 'AmBizSelectKng'
})], AmBizSelectKng);
export default AmBizSelectKng;